<template>
	<div>
        <div>
			<span class="xbed-sub-title">管家即时账务列表</span>
		</div>
		<div class="xbed-breadcrumb">
			<Breadcrumb>
				<BreadcrumbItem>麗家会</BreadcrumbItem>
				<BreadcrumbItem>管家即时账务列表</BreadcrumbItem>
			</Breadcrumb>
		</div>
        <br>
        <Form @submit.native.prevent="preventSubmit" inline>
            <Row>
                <FormItem  label="结算时间：" :label-width="84">
                    <DatePicker v-model="queryParams.month" type="month"  placeholder="选择日期" style="width: 150px" :clearable="false" @on-change="changeDate"></DatePicker>
                </FormItem>

                <FormItem label="管家：" :label-width="80">
                    <Input type="text" placeholder="搜索ID、姓名、手机号" v-model="queryParams.housekeeper"></Input>
                </FormItem>

                <FormItem>
                    <Button type="primary" @click="queryKeeperBillListFn" :loading="queryBtn">查询</Button>
                </FormItem>

                <FormItem>
                    <Button type="primary" :loading="exportBtn">
                        <downloadexcel
                          class = "btn"
                          :name = "excelName"
                          :fetch = "exportTableData"
                          :fields = "json_fields"
                          :before-finish = "finishDownload">
                          导出筛选结果
                        </downloadexcel>
                    </Button>
                </FormItem>

                <FormItem>
                    <Button type="error" @click="showEntryRewardAndFineModal">录入奖惩</Button>
                </FormItem>
            </Row>           
        </Form>

        <Content>
            <Table :columns="columns" :data="keeperBillList" class="keeperBillList"></Table>
            <div style="margin: 10px; overflow: hidden;">
                <Page show-sizer placement="top"
                :total="listTotal"
                :current="queryParams.page"
                :page-size="queryParams.rows"
                @on-page-size-change="changePageSize"
                @on-change="changePage"></Page>
            </div>
        </Content>

         <Modal class="cloth-washing-fee"
            v-model="entryRewardAndFineModal.display"
            ref="entryRewardFineModal"
            :loading="true"
            title="录入惩罚"
            width="650"
            :closable="false"
            ok-text="保存"
            @on-ok="confirmEntryRewardFineFn">
            <Form :label-width="100" ref="entryRewardFineModalForm" :rules="modalDataRules">
                <FormItem label="管家手机号" prop="cleanerAccount">
                    <Input v-model="entryRewardAndFineModal.data.cleanerAccount" :maxlength="11" placeholder=""></Input>
                </FormItem>
                <FormItem label="金额(元)" prop="costMoney">
                    <Input v-model="entryRewardAndFineModal.data.costMoney"  placeholder=""></Input>
                </FormItem>
                <FormItem label="原因" prop="reason">
                    <Input v-model="entryRewardAndFineModal.data.reason" :maxlength="100" placeholder=""></Input>
                </FormItem>
            </Form>
        </Modal>
    </div>
</template>

<script>
import Moment from "moment";
import API from "@/api";
import Utils from "@/utils";
import downloadexcel from "vue-json-excel";
// import Config from "@/config";

export default { 
    components: {
        downloadexcel,
    },
    data() {
        const validateList = {
            cleanerAccount: ( rule, value, callback ) => {
                if (!this.entryRewardAndFineModal.data.cleanerAccount) {
                    callback( new Error( '手机号码不能为空' ) )
                } else {
                    callback();
                }
            },
            costMoney: ( rule, value, callback ) => {
                if (!this.entryRewardAndFineModal.data.costMoney) {
                    callback( new Error( '金额不能为空' ) )
                } else {
                    callback();
                }
            },
            reason: ( rule, value, callback ) => {
                if (!this.entryRewardAndFineModal.data.reason) {
                    callback( new Error( '备注不能为空' ) )
                } else {
                    callback();
                }
            },
        }
        return {
            exportBtn: false,
            excelName: '',
            modalDataRules: {
                cleanerAccount: [
                    {validator: validateList.cleanerAccount, required: true, trigger: 'blur'}
                ],
                costMoney: [
                    {validator: validateList.costMoney, required: true, trigger: 'blur'}
                ],
                reason: [
                    {validator: validateList.reason, required: true, trigger: 'blur'}
                ]
            },
            queryBtn: false,
            queryParams: {
                month: Moment()
					.add( "month" )
					.format( "YYYY-MM" ),
				housekeeper: "",
				page: 1,
				rows: 10,
            },
            entryRewardAndFineModal: {
                display: false,
                data: {
                    cleanerAccount: '',
                    costMoney: '',
                    reason: ''
                },
                initData: {
                    cleanerAccount: '',
                    costMoney: '',
                    reason: ''
                }
            },
            listTotal: 0,
            keeperBillList: [],
            columns: [
                {
                    title: '管家ID_姓名_手机号',
                    key: 'cleanerId',
                    align: 'center',
                    fixed: 'left',
                    width: 260,
                    render: (h,params) => {
						return h('div',params.row.cleanerId + "_" + params.row.cleanerName + "_" + params.row.cleanerAccount)
					}
                },
                {
                    title: '身份证',
                    key: 'cardId',
                    align: 'center',
                    width: 190
                },
                {
                    title: '清洁基本薪酬(元)',
                    key: 'baseMoney',
                    align: 'center',
                    width: 100
                },
                {
                    title: '值班基本薪酬(元)',
                    key: 'dutyOrderMoney',
                    align: 'center',
                    width: 100
                },
                {
                    title: '平台补贴(元)',
                    key: 'platformSubsidies',
                    align: 'center',
                    width: 100
                },
                {
                    title: '业主补贴(元)',
                    key: 'hostSubsidies',
                    align: 'center',
                    width: 100
                },
                {
                    title: '福利补贴(元)',
                    key: 'cleanSubsidies',
                    align: 'center',
                    width: 100
                },
                {
                    title: '超时扣罚(元)',
                    key: 'systemFineMoney',
                    align: 'center',
                    width: 100
                },
                {
                    title: '评价奖励(元)',
                    key: 'evaluationRewardMoney',
                    align: 'center',
                    width: 100
                },
                {
                    title: '评价扣罚(元)',
                    key: 'evaluationFineMoney',
                    align: 'center',
                    width: 100
                },
                {
                    title: '人工录入平台补贴(元)',
                    key: 'artificialRewardMoney',
                    align: 'center',
                    width: 100
                },
                {
                    title: '清洁平台扣罚(元)',
                    key: 'artificialFineMoney',
                    align: 'center',
                    width: 100
                },
                {
                    title: '值班平台扣罚(元)',
                    key: 'dutyOrderFineMoney',
                    align: 'center',
                    width: 100
                },
                {
                    title: '保险费(元)',
                    key: 'insuranceMoney',
                    align: 'center',
                    width: 100
                },
                {
                    title: '收入小结(元)',
                    key: 'incomeSummaryMoney',
                    align: 'center',
                    width: 100
                },
                {
                    title: '支出小结(元)',
                    key: 'expenditureSummaryMoney',
                    align: 'center',
                    width: 100
                },
                {
                    title: '汇总(元)',
                    key: 'totalMoney',
                    align: 'center',
                    width: 100
                },
                {
                    title: '操作',
                    align: 'center',
                    width: 160,
                    render: (h, params) => {
                        return h("div", [
                            h(
                                "Button",
                                {
                                    props: {
                                        size: "small"
                                    },
                                    style: {
                                        marginLeft:'10px',
                                    },
                                    on: {
                                        click: () => {
                                            if (!Utils.hasPermission('paymentDetails')) {
                                                this.$Notice.error({
                                                title: "无权限操作"
                                                });
                                                return
                                            }
                                            this.queryParams.month = this.queryParams.month
                                                ? Moment( this.queryParams.month ).format( "YYYY-MM" )
                                                : "";
                                            if ( this.$router ) {
												window.open( `#/app/cleaner/paymentDetails?cleanerId=${ params.row.cleanerId }&&month=${this.queryParams.month}` )      //跳转至管家库存明细表 
											} else {
												window.open( `#/Cleaner/Cleaner/paymentDetails?cleanerId=${ params.row.cleanerId }&&month=${this.queryParams.month}` );
											}
                                        }
                                    }
                                },
                                "详情"
                            ),
                            h(
                                "Button",
                                {
                                    props: {
                                        type: "error",
                                        size: "small"
                                    },
                                    style: {
                                        marginLeft:'10px',
                                    },
                                    on: {
                                        click: () => {
                                            this.showEntryRewardAndFineModal()
                                            this.entryRewardAndFineModal.data.cleanerAccount = params.row.cleanerAccount
                                        }
                                    }
                                },
                                "录入奖惩"  
                            )
                        ])
                    }
                },
            ],
            json_fields: {
                "管家ID": "cleanerId",
                "姓名": "cleanerName",
                "手机号": "cleanerAccount",
                "身份证": {field: "cardId", callback: value => { return "&nbsp;" + value }},
                "清洁基本薪酬(元)": "baseMoney",
                "值班基本薪酬(元)": "dutyOrderMoney",
                "平台补贴(元)": "platformSubsidies",
                "业主补贴(元)": "hostSubsidies",
                "福利补贴(元)": "cleanSubsidies",
                "超时扣罚(元)": "systemFineMoney",
                "评价奖励(元)": "evaluationRewardMoney",
                "评价扣罚(元)": "evaluationFineMoney",
                "人工录入平台补贴(元)": "artificialRewardMoney",
                "清洁平台扣罚(元)": "artificialFineMoney",
                "值班平台扣罚(元)": "dutyOrderFineMoney",
                "保险费(元)": "insuranceMoney",
                "收入小结(元)": "incomeSummaryMoney",
                "支出小结(元)": "expenditureSummaryMoney",
                "汇总(元)": "totalMoney",
                "银行名": "bankName",
                "支行名": "bankBranchName",
                "银行卡号": {field: "bankAccount", callback: value => { return "&nbsp;" + value }},
            }
        }
    },

    created() {
        this.token = Utils.findFromLocalStorage('vue-token');
		this.username = Utils.findFromLocalStorage('vue-username');
		this.env = Utils.findFromLocalStorage('env', 'dev');
        this.AuthorToken = Utils.findFromLocalStorage('Author-token');
        this.headerENV = Utils.aliHeaderEnv(this.env)

        if (!Utils.hasPermission('housekeeperBillList')) {
            this.$Notice.error({
            title: "无权限操作"
            });
            return
        }

        this.queryKeeperBillListFn();
        this.excelName = `管家即时账务表_${Moment( this.queryParams.month ).format( "YYYY-MM" )}.xls`
    },

    methods: {
        changePage(pageIndex) {
          this.queryParams.page = pageIndex;
          this.queryKeeperBillListFn();
        },
        changePageSize(pageSize) {
            this.queryParams.page = 1;
			this.queryParams.rows = pageSize;
			this.queryKeeperBillListFn();
        },
        async queryKeeperBillListFn() {
            this.queryParams.month = this.queryParams.month
				? Moment( this.queryParams.month ).format( "YYYY-MM" )
				: "";
            let res = (await API.omsAPI[this.env].clientServer.housekeeperBillListByPage(this.queryParams, {
                'x-ca-stage': this.headerENV,
                'Authorization': this.AuthorToken,
            })).data;
            if (res.retCode || res.code !== '0000') {
                this.$Notice.error( {
                title: '错误',
                desc: `获取管家即时财务列表失败：${res.msg}`
                })
                return
            }
            this.keeperBillList = res.data.list || [];
            this.listTotal = res.data.rowCount || 0;
        },
        async exportTableData() {
            if (!Utils.hasPermission('keeperBillExportExcel')) {
                this.$Notice.error({
                title: "无权限操作"
                });
                return
            }
            if ( this.keeperBillList.length === 0 ) {
				this.$Notice.error( {
					title: "没数据可导"
				} );
				return;
			}
            Moment( this.queryParams.month ).format( "YYYY-MM" )
            let params = {
                month: this.queryParams.month
				? Moment( this.queryParams.month ).format( "YYYY-MM" ): "",
                housekeeper: this.queryParams.housekeeper
            };
            let exprot_env = API.omsAPI[this.env];
            let header =  {
                'x-ca-stage': this.headerENV,
                'Authorization': this.AuthorToken,
            };
            this['exportLoading'] = true;
			const response = (await exprot_env.clientServer.exportHouseKeeperBillList(params, header)).data;
            this.excelName = `管家即时账务表_${Moment( this.queryParams.month ).format( "YYYY-MM" )}.xls`
            return response.data;
        },
        finishDownload(){
            this['exportLoading'] = false;
        },
        preventSubmit() {
            return false
        },
        showEntryRewardAndFineModal() {
            if (!Utils.hasPermission('entryRewardAndFine')) {
                this.$Notice.error({
                title: "无权限操作"
                });
                return
            }
            this.entryRewardAndFineModal.display = true
        },
        async confirmEntryRewardFineFn() {
            let validResult = false;
            this.$refs.entryRewardFineModalForm.validate( valid => {
                validResult = valid
            } );
            if ( !validResult ) {
                this.$refs.entryRewardFineModal.buttonLoading = false;
                return;
            }
            let params = {
                cleanerAccount: this.entryRewardAndFineModal.data.cleanerAccount,
                costMoney: this.entryRewardAndFineModal.data.costMoney * 100,
                reason: this.entryRewardAndFineModal.data.reason,
                project: "",
                createName: this.username
            }
            let res = (await API.omsAPI[this.env].clientServer.entryRewardAndFine(params, {
                'x-ca-stage': this.headerENV,
                'Authorization': this.AuthorToken,
            })).data;
            if (res.retCode || res.code !== '0000') {
                this.$Notice.error( {
                title: '错误',
                desc: `录入奖惩信息失败：${res.msg}`
                })
                return
            }else {
                this.$Notice.success({
                    title: '操作成功'
                })
                this.entryRewardAndFineModal.display =false
                this.entryRewardAndFineModal.data = Object.assign({}, this.entryRewardAndFineModal.initData)
            }
            this.$refs.entryRewardFineModal.buttonLoading = true;
        },
        changeDate() {
            this.queryKeeperBillListFn()
        }
    }
}
</script>

<style>
.keeperBillList .ivu-table-cell {
  padding-left: 20px;
  padding-right: 0;
}
</style>


// WEBPACK FOOTER //
// src/pages/cleaner/housekeeperBill-list.vue